import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectStrobeFeatures } from '@redux/situation/situation.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

import { strobeAzimuthLayer, strobeSectorLayer } from './strobe.layer';

function StrobeLayer() {
  const strobeFeatures = useSelectorWithReplayMode(selectStrobeFeatures);

  if (!isFeatureCollection(strobeFeatures)) return null;

  return (
    <Source id={SourceNameEnum.STROBES} type="geojson" data={strobeFeatures}>
      <Layer {...strobeSectorLayer} />
      <Layer {...strobeAzimuthLayer} />
    </Source>
  );
}

export default StrobeLayer;
